import useDocumentTitle from "hooks/useDocumentTitle";
import { TabPanel, TabView } from "primereact/tabview";

import { AccessReviewTable } from "./components/AccessReviewTable";
import { UsersTable } from "./components/UsersTable";

export function UsersPage() {
  useDocumentTitle("List Users");

  return (
    <TabView className="w-full">
      <TabPanel header="Users">
        <UsersTable />
      </TabPanel>
      {/* CLE-2765. The /users page is SuperAdmin-only; the API endpoints are too. */}
      <TabPanel header="Access review">
        <AccessReviewTable />
      </TabPanel>
    </TabView>
  );
}
